/* eslint-disable react/jsx-curly-newline */
import { useTranslate } from 'hooks/useTranslate';
import { useHistory } from 'react-router-dom';

import Page from 'modules/_shared/components/Pages/Page';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import OperationMenuDots from 'modules/_shared/components/MenuDots/OperationMenuDots';
import { useDraftsList } from 'modules/drafts/hooks/useDraftsList';
import { useGetDraftsSectionPermissions } from 'modules/drafts/hooks/useGetDraftsSectionPermissions';

import { useMemo } from 'react';
import DraftsRow from 'modules/drafts/components/DraftsRow';
import EmptyStateCard from 'modules/_shared/components/EmptyStates/EmptyStateCard';
import menuOptions from './menuOptions';

const DraftsList = () => {
  const { t } = useTranslate();
  const history = useHistory();

  const { isAdmin, isReadOnly } = useGetDraftsSectionPermissions().data;
  const {
    data: { drafts, actualSociety },
    isLoading,
  } = useDraftsList();

  const rows = useMemo(() => {
    if (!drafts?.length || !actualSociety) {
      return [];
    }

    return drafts.map((draft, index) => (
      <DraftsRow
        key={draft._id}
        index={index + 1}
        societyId={actualSociety?._id || ''}
        draft={draft}
      />
    ));
  }, [drafts, actualSociety]);

  return (
    <Page id="drafts-list-page">
      <PageListHeader
        subTitle={t('OperationsDrafts')}
        description={`${actualSociety?.name || ''} ${t('HaveDrafts', {
          count: rows?.length,
        })}`}
        actions={
          isAdmin && [
            <OperationMenuDots
              title={t('AddDraft')}
              menuOptions={menuOptions}
              handleModal={(menuOption: string) =>
                history.push(`${menuOption}/${actualSociety?._id || ''}`)
              }
              disabled={isReadOnly}
            />,
          ]
        }
      />

      {rows.length > 0 ? (
        <div className="card card-bordered card-preview">
          <table className="nk-tb-list nk-tb-ulist">
            <thead>
              <tr className="nk-tb-item nk-tb-head tb-tnx-head">
                <th className="nk-tb-col tb-col-xl text-center">
                  <span>{t('Nr')}</span>
                </th>
                <th className="nk-tb-col text-center">
                  <span>{t('Name')}</span>
                </th>
                <th className="nk-tb-col text-center">
                  <span>{t('DraftDate')}</span>
                </th>
                <th className="nk-tb-col tb-col-xl text-center">
                  <span>{t('Percentage')}</span>
                </th>
                <th className="nk-tb-col tb-col-xl text-center">
                  <span>{t('PreMoneyValue')}</span>
                </th>
                <th className="nk-tb-col text-center">
                  <span>{t('Amount')}</span>
                </th>
                <th className="nk-tb-col text-center">
                  <span>{t('Operation')}</span>
                </th>
                <th className="nk-tb-col tb-col-xl text-center">
                  <span>{t('Status')}</span>
                </th>

                <th className="nk-tb-col text-center">
                  <span />
                </th>
              </tr>
            </thead>

            <tbody>{rows}</tbody>
          </table>
        </div>
      ) : (
        <EmptyStateCard
          mainMessage={t('NoDrafts')}
          infoMessage={t('NoDraftsInfo')}
        />
      )}

      {isLoading && <CustomLoading />}
    </Page>
  );
};

export default DraftsList;
